import { Component, Injectable, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-period-selector',
  templateUrl: './period-selector.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppPeriodSelectorComponent),
      multi: true
    }
  ]
})

@Injectable()
export class AppPeriodSelectorComponent implements ControlValueAccessor {
  private _selectedPeriod: string;
  _periodValue: Date;
  nextMonth: string;
  prevMonth: string;
  isOpen = false;

  constructor() {
      this.periodValue = new Date();
    }

  @Input() showPrevButton = true;
  @Input() showNextButton = true;
  @Output() changed: EventEmitter<string> = new EventEmitter();

  @Output() get model () {
    return this._selectedPeriod;
  }

  get periodValue(): Date {
    return this._periodValue;
  }

  set periodValue(value: Date) {
    if (value != null && value !== this._periodValue) {
        this._selectedPeriod = moment(value).format('MMMM-YYYY');
        this._periodValue = value;
        this.propagateChange(this._selectedPeriod);
    }
  }

  writeValue(value: string): void {
    if (value != null && value !== this._selectedPeriod) {
      this._selectedPeriod = value;
      this.periodValue = moment(value, 'MMMM-YYYY').toDate();
    }
  }

  propagateChange = (_: any) => {};
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }


  dpOnShown(event) {
    this.isOpen = true;
    event.setViewMode('month');
    event.monthSelectHandler = (ev) => {this.periodValue = ev.date; };
  }

  previousMonthClick(): void {
    this.periodValue = moment(this.periodValue).add(-1, 'month').toDate();
  }

  nextMonthClick(): void {
      this.periodValue = moment(this.periodValue).add(1, 'month').toDate();
  }

  periodChanged(event: Date) {
    if (event != null) {
        this.nextMonth = moment(event).add(1, 'month').format('MMMM-YYYY');
        this.prevMonth = moment(event).add(-1, 'month').format('MMMM-YYYY');
        this._selectedPeriod =  moment(event).format('MMMM-YYYY');
        this.changed.emit(this._selectedPeriod);
    }
  }

}

